import { useTranslation } from '@embed/hooks/react-i18nextLazy';
export const SponsoredText = (props) => {
    const { video } = props;
    const { t } = useTranslation();
    const sponsored = !!(video === null || video === void 0 ? void 0 : video.badge) && video.badge === 'ad';
    const featured = !!(video === null || video === void 0 ? void 0 : video.badge) && video.badge === 'featured';
    // Add <span> around translated texts to work around #1813
    // https://github.com/facebook/react/issues/11538.
    if (sponsored) {
        return <span className="cy-sponsored">{t('Sponsored')}</span>;
    }
    if (featured) {
        return <span>{t('Featured')}</span>;
    }
    return null;
};
